function pickFirstNonBlank(values = []) {
  for (const value of values) {
    const text = String(value ?? "").trim();
    if (text) return text;
  }
  return "";
}

export function parsePsychologistIdToken(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return null;
  const token = raw.split("-")[0];
  const numeric = Number(token);
  return Number.isFinite(numeric) && numeric > 0 ? Math.trunc(numeric) : null;
}

export function normalizePsychologistLogin(value) {
  const raw = String(value ?? "").trim();
  if (!raw) return null;
  const normalized = raw.toLowerCase();
  return /^[a-z0-9_.-]{3,32}$/.test(normalized) ? normalized : null;
}

function extractProfileIdentity(input) {
  if (input && typeof input === "object" && !Array.isArray(input)) {
    const login = normalizePsychologistLogin(
      pickFirstNonBlank([
        input.login,
        input.userLogin,
        input.user?.login,
        input.author?.login,
      ])
    );
    const id = parsePsychologistIdToken(
      pickFirstNonBlank([
        input.userId,
        input.id,
        input.user?.id,
        input.author?.id,
      ])
    );
    return { id, login };
  }

  const raw = String(input ?? "").trim();
  if (!raw) return { id: null, login: null };
  if (/^\/psychologist\/[^/]+\/?$/i.test(raw)) {
    const segment = raw.replace(/^\/psychologist\//i, "").replace(/\/$/, "");
    return { id: parsePsychologistIdToken(segment), login: normalizePsychologistLogin(segment) };
  }
  return { id: parsePsychologistIdToken(raw), login: normalizePsychologistLogin(raw) };
}

export function buildPsychologistProfilePath(input) {
  const { id, login } = extractProfileIdentity(input);
  if (login) return `/psychologist/${encodeURIComponent(login)}`;
  if (id != null) return `/psychologist/${encodeURIComponent(String(id))}`;
  return "";
}

export function isExternalHttpUrl(value) {
  return /^https?:\/\//i.test(String(value || "").trim());
}

export function resolvePsychologistProfileRoute(profileUrl, psychologistUserId) {
  const fallback = buildPsychologistProfilePath(psychologistUserId);
  const raw = String(profileUrl || "").trim();
  if (!raw) return fallback;

  if (isExternalHttpUrl(raw)) {
    try {
      const parsed = new URL(raw);
      const absolutePath = `${parsed.pathname}${parsed.search || ""}${parsed.hash || ""}`;
      const matchPsychologists = parsed.pathname.match(/^\/psychologists\/([^/]+)\/?$/i);
      if (matchPsychologists?.[1]) return buildPsychologistProfilePath(matchPsychologists[1]);
      if (/^\/psychologist\/[^/]+\/?$/i.test(parsed.pathname)) return absolutePath;
      return raw;
    } catch {
      return fallback;
    }
  }

  const matchPsychologists = raw.match(/^\/psychologists\/([^/]+)\/?$/i);
  if (matchPsychologists?.[1]) return buildPsychologistProfilePath(matchPsychologists[1]);
  if (/^\/psychologist\/[^/]+\/?$/i.test(raw)) return raw;
  if (raw.startsWith("/")) return raw;
  const fromToken = buildPsychologistProfilePath(raw);
  if (fromToken) return fromToken;
  return fallback;
}
